/**
 * Map a scheduled prepared drop's executeAfter onto a target work date (Copenhagen wall clock).
 * For Media Devoted | Created By Ciro Autiero
 *
 * `sourceWorkDateYmd` is the work day the original belonged to. A drop authored
 * on the 13th for 05:44 is planned for the 14th — a late local send — and that
 * one-day gap is the point of it. Passing the source day carries the gap onto
 * the copy; omitting it keeps the old same-day behaviour.
 */

import { shiftScheduleTemplateToWorkDate } from '@trafficpulse/shared';

export function shiftedExecuteAfterForCopiedDrop(
  executeAfter: string | null | undefined,
  targetWorkDateYmd: string,
  sourceWorkDateYmd?: string | null,
  nowUtc: Date = new Date(),
): string | undefined {
  const raw = executeAfter?.trim();
  if (!raw) return undefined;
  const templateAt = new Date(raw);
  if (Number.isNaN(templateAt.getTime())) return undefined;
  return shiftScheduleTemplateToWorkDate({
    templateAt,
    workDateYmd: targetWorkDateYmd.trim(),
    sourceWorkDateYmd: sourceWorkDateYmd?.trim() || undefined,
    nowUtc,
  }).toISOString();
}
